import React, { Component } from "react";
import Field from "./Field";
import { FieldArray } from "formik";

import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faPlusCircle, faTimesCircle } from '@fortawesome/free-solid-svg-icons'

class FieldRepeater extends Component {
  constructor(props) {
    super(props);

    this.addable = true;

    if (
      "ui:options" in this.props.uiSchema &&
      "addable" in this.props.uiSchema["ui:options"]
    ) {
      this.addable = this.props.uiSchema["ui:options"].addable;
    }

    this.buildRows = this.buildRows.bind(this);
  }

  buildRows(arrayHelpers) {
    let { errors, schema, uiSchema, ...props } = this.props;
    let { name, value, ...fieldConfig } = props.fieldConfig;

    return value.map((row, index) => (
      <div key={`${name}.${index}`}>
        {uiSchema.items["ui:order"].map((id, i) => {
          let newid = id.substring(id.indexOf(".") + 1);

          return (
            <Field
              key={`${name}.${index}[${newid}]`}
              id={`${name}.${index}[${newid}]`}
              schema={schema.items.properties[id]}
              uiSchema={uiSchema.items[id]}
              errors={errors}
              handleChange={fieldConfig.onChange}
              handleBlur={fieldConfig.onBlur}
              orientation="horizontal"
              value={value[index][newid]}
            />
          );
        })}
        {this.addable && (
          <p>
            <button
              type="button"
              className="btn btn-outline-danger offset-md-3"
              onClick={() => arrayHelpers.remove(index)}
            >
              <FontAwesomeIcon icon={faTimesCircle} /> Remove
            </button>
          </p>
        )}
        <hr />
      </div>
    ));
  }

  render() {
    let { name, value } = this.props.fieldConfig;
    let showAddButton = false;

    if (
      this.addable &&
      !(
        "maxItems" in this.props.schema &&
        value.length >= this.props.schema.maxItems
      )
    ) {
      showAddButton = true;
    }

    return (
      <FieldArray
        name={name}
        render={arrayHelpers => (
          <div className="w-100">
            {this.buildRows(arrayHelpers)}
            {showAddButton && (
              <button
                className="btn btn-outline-secondary"
                type="button"
                onClick={() => arrayHelpers.push({})}
              >
                <FontAwesomeIcon icon={faPlusCircle} /> Add
              </button>
            )}
          </div>
        )}
      />
    );
  }
}

export default FieldRepeater;



// WEBPACK FOOTER //
// ./src/FieldRepeater.js